import LandingForm from './common/LandingForm';
import SuccessPage from './common/SuccessPage';

import ContactReasonForm from './ComplaintComplimentFeedback/YourDetailsForm';
import ComplaintDetailsForm from './ComplaintComplimentFeedback/ComplaintDetailsForm';
import YourDetailsForm from './FinancialHardship/YourDetailsForm';
import TellUsMoreForm from './FinancialHardship/TellUsMoreForm';
import EmploymentForm from './FinancialHardship/EmploymentForm';
import IncomeExpenseForm from './FinancialHardship/IncomeExpenseForm';

import {
  CUSTOMER_FORM_STEP1,
  CUSTOMER_FORM_STEP2,
  CUSTOMER_FORM_STEP3,
  CUSTOMER_FORM_FIN_STEP4,
  CUSTOMER_FORM_FIN_STEP5,
  CUSTOMER_FORM_LAST_STEP,
  ANALYTICS_NAMES,
} from 'utils/constants';

export const nonFinancialSteps = [
  { name: CUSTOMER_FORM_STEP1, analyticsName: ANALYTICS_NAMES.LANDING, component: LandingForm },
  { name: CUSTOMER_FORM_STEP2, analyticsName: ANALYTICS_NAMES.YOUR_DETAILS, component: ContactReasonForm },
  { name: CUSTOMER_FORM_STEP3, analyticsName: ANALYTICS_NAMES.TELL_US_MORE, component: ComplaintDetailsForm },
  { name: CUSTOMER_FORM_LAST_STEP, analyticsName: ANALYTICS_NAMES.LAST_STEP, component: SuccessPage },
];

export const financialSteps = [
  { name: CUSTOMER_FORM_STEP1, analyticsName: ANALYTICS_NAMES.LANDING, component: LandingForm },
  { name: CUSTOMER_FORM_STEP2, analyticsName: ANALYTICS_NAMES.YOUR_DETAILS, component: YourDetailsForm },
  { name: CUSTOMER_FORM_STEP3, analyticsName: ANALYTICS_NAMES.TELL_US_MORE, component: TellUsMoreForm },
  { name: CUSTOMER_FORM_FIN_STEP4, analyticsName: ANALYTICS_NAMES.EMPLOYMENT, component: EmploymentForm },
  { name: CUSTOMER_FORM_FIN_STEP5, analyticsName: ANALYTICS_NAMES.INCOME_EXPENSES, component: IncomeExpenseForm },
  { name: CUSTOMER_FORM_LAST_STEP, analyticsName: ANALYTICS_NAMES.LAST_STEP, component: SuccessPage },
];
